<template>
  <div>
    <Title :pages="[{ icon: 'mdi-file-document-multiple', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <div class="content-main">
        <v-tabs v-model="tab">
          <v-tab v-for="item in items" :key="item.key">
            {{ item.tab }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item key="0">
            <DocumentLogs />
          </v-tab-item>
          <v-tab-item key="1">
            <EmailLogs />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-container>
  </div>
</template>

<script>
import Title from "@/components/Title.vue";
import DocumentLogs from "./DocumentLogs.vue";
import EmailLogs from "./EmailLogs.vue";
import RolMixin from "@/mixins/RolMixin.vue";

export default {
  components: { 
    Title,
    DocumentLogs,
    EmailLogs
  },
  mixins: [RolMixin],
  data() {
    return {
      page_title: "Logs de actividad",
      tab: 0,
      items: [
        { tab: "Documentos", key: 0 },
        { tab: "Email", key: 1 },
      ],
    };
  },
};
</script>